var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.333 3.073c0-.776.598-1.406 1.334-1.406h8c.736 0 1.333.63 1.333 1.406v12.23h.667c.368 0 .666.305.666.682a.674.674 0 0 1-.666.682h-12A.674.674 0 0 1 5 15.985c0-.377.298-.682.667-.682h.667V3.073Zm4 12.23H13V13.3c0-.776-.597-1.406-1.333-1.406s-1.334.63-1.334 1.406v2.003Zm-1.777-7.5a.458.458 0 0 0-.445.469v.937c0 .258.2.47.445.47h.888c.245 0 .445-.212.445-.47v-.937c0-.258-.2-.469-.445-.469h-.888Zm3.555 0h-.889a.458.458 0 0 0-.444.469v.937c0 .258.2.47.444.47h.89c.244 0 .444-.212.444-.47v-.937c0-.258-.2-.469-.445-.469Zm1.778 0a.458.458 0 0 0-.445.469v.937c0 .258.2.47.445.47h.889c.244 0 .444-.212.444-.47v-.937c0-.258-.2-.469-.444-.469h-.89Zm-4.445-3.75h-.888a.458.458 0 0 0-.445.469v.937c0 .258.2.47.445.47h.888c.245 0 .445-.212.445-.47v-.937c0-.258-.2-.469-.445-.469Zm1.778 0a.458.458 0 0 0-.444.469v.937c0 .258.2.47.444.47h.89c.244 0 .444-.212.444-.47v-.937c0-.258-.2-.469-.445-.469h-.889Zm3.556 0h-.89a.458.458 0 0 0-.444.469v.937c0 .258.2.47.445.47h.889c.244 0 .444-.212.444-.47v-.937c0-.258-.2-.469-.444-.469Z",
    fill: "#1C3F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.278 14.167a4.445 4.445 0 1 1-8.89 0 4.445 4.445 0 0 1 8.89 0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.833 10.278a3.889 3.889 0 1 0 0 7.778 3.889 3.889 0 0 0 0-7.778Zm-5 3.889a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
    fill: "#1C3F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.833 16.389 2.963-2.222-2.963-2.223v1.482H2.87v1.481h2.963v1.482Z",
    fill: "#1C3F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/business-icon.2e2691329ed42c7fb1e94d93f091abd9.svg";
export { ForwardRef as ReactComponent };